export default "__VITE_ASSET__eb04c438__"